var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon40({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.753 5.049L12.29.204A.687.687 0 0011.787 0c-.2 0-.385.076-.503.204L6.819 5.049a.423.423 0 00-.055.525c.105.169.322.277.558.277h1.607v10.804c0 .277.28.502.625.502h4.464c.346 0 .626-.225.626-.502V5.85h1.607c.236 0 .452-.108.558-.277a.423.423 0 00-.056-.525M3.214 10.768h-.915c-1.268 0-2.3.829-2.3 1.848v4.039c0 .278.28.502.626.502h2.697a1.245 1.245 0 01-.108-.502v-5.887z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.678 8.076h-.914c-1.267 0-2.3.829-2.3 1.848v6.731c0 .278.28.502.626.502h2.696a1.245 1.245 0 01-.108-.502v-8.58z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon40);
export default __webpack_public_path__ + "static/media/icon_40.2c560559987a8e28b0bb1b51b9ebc8a2.svg";
export { ForwardRef as ReactComponent };